import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.div(
    ({ theme: { gradients } }) => css`
        align-items: center;
        background: ${gradients.primary};
        display: flex;
        height: 80px;
        justify-content: space-between;
        left: 0;
        padding: 14px 82px;
        position: fixed;
        right: 0;
        top: 0;
        z-index: 99;
    `,
);

export const HeaderLink = styled(Link)`
    text-decoration: none;
`;

export const Logo = styled.img`
    height: 33px;
    width: 212px;
`;
